import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";

import { useLanguage } from "../../context/languageContext";

// The row counts beside the nav labels.
//
// One `GET /api/admin/dashboard` for all six. The Dashboard page already calls
// the same endpoint; this is a second call on the pages that are not it, which
// is the cost of showing the numbers on every screen. It fails silently — a
// missing count just means no badge, and the nav still navigates.
export const useDashboardCounts = () => {
  const { adminInfo } = useLanguage();
  const token = adminInfo?.token;
  const [counts, setCounts] = useState(null);
  // The sidebar remounts on every route change (each Route wraps its own
  // <SideNavBar>), so without this the whole nav would refetch on every click.
  const fetched = useRef(false);

  const client = useMemo(
    () =>
      axios.create({
        baseURL: process.env.REACT_APP_API_ROOT,
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      }),
    [token]
  );

  useEffect(() => {
    if (!token || fetched.current) return;
    fetched.current = true;
    let alive = true;
    client
      .get("/api/admin/dashboard")
      .then(({ data }) => {
        if (alive && data?.status) setCounts(data.data);
      })
      .catch(() => {
        // Counts are decoration. Leave them off rather than surfacing an error
        // in the navigation.
      });
    return () => {
      alive = false;
    };
  }, [client, token]);

  return counts;
};

// 11019 → "11,019", matching the design. Anything non-numeric is dropped
// rather than rendered as "NaN".
export const formatCount = (value) =>
  typeof value === "number" && Number.isFinite(value)
    ? value.toLocaleString("en-US")
    : null;
